var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "applicationManager" } },
    [
      _c(
        "div",
        {
          staticClass: "header-page",
          class: { "header-page-long": !_vm.is_sidebar_minimized }
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center"
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("img", {
                  staticClass: "back-to-list",
                  attrs: { src: require("@/assets/icon/arrow-left.svg") },
                  on: {
                    click: function($event) {
                      _vm.$router.push("/application-manager")
                    }
                  }
                }),
                _vm._v(" "),
                _vm.isLoading
                  ? _c("div", {
                      staticClass: "skeleton-box",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "margin-bottom": "0 !important"
                      }
                    })
                  : _c("h3", { staticClass: "application-name" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.application_detail.name) +
                          "\n        "
                      )
                    ])
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-ellipsis-v fa-lg popover-config",
                attrs: { id: "popover-config-menu" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tabs" },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "div",
                {
                  key: tab.id,
                  staticClass: "tab-list",
                  class: { "tab-active": _vm.tabActive === tab.id },
                  on: {
                    click: function($event) {
                      _vm.changeTab(tab.id)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(tab.label) + "\n      ")]
              )
            })
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wrap-content bg-canvas",
          class: { "wrap-content-long": !_vm.is_sidebar_minimized }
        },
        [
          _vm.tabActive === "layout" ? _c("j-component-library") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "application-content" },
            [
              _vm.tabActive === "general"
                ? _c("j-general-tab")
                : _vm.tabActive === "layout"
                ? _c("j-layout-tab")
                : _vm.tabActive === "data-source"
                ? _c("j-data-source-tab")
                : _vm.tabActive === "experience-manager"
                ? _c("j-exp-manager-tab")
                : _vm.tabActive === "visual-programming"
                ? _c("j-visprog-tab")
                : _vm.tabActive === "analytic-dashboard"
                ? _c("j-analytic-tab")
                : _vm.tabActive === "variables"
                ? _c("j-variables-tab")
                : _vm.tabActive === "api-manager"
                ? _c("j-api-manager-tab")
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "configPopoverRef",
          attrs: { target: "popover-config-menu", placement: "left" }
        },
        [
          _c(
            "div",
            { staticClass: "form-ui-opt", on: { click: _vm.deleteApp } },
            [_vm._v("\n      Delete Application\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-ui-opt", on: { click: _vm.backToV1 } },
            [_vm._v("\n      Back to V1\n    ")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4265fe22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4265fe22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/jAppManagerDetail.vue
// module id = null
// module chunks = 